<template>
  <div class="modal">
    <div class="modal-background"></div>
    <div class="modal-card" qa="templates-modal">
      <button @click="close" class="delete close-button" aria-label="close" qa="close-templates-modal"></button>
      <div v-if="!$isYSC" class="tour-container">
        <p> {{ $t("template.before") }}</p>
        <button class="save button is-primary gtm-video-tour is-uppercase has-text-weight-bold tour-button" @click="openVideoTour"><i class="fal fa-play-circle is-size-5"></i>  {{ $t("template.tour") }}</button>
      </div>
      <div class="header-wrapper">
        <div class="modal-header title is-uppercase is-left">
          {{ title }}
        </div>
        <div v-if="resourceLink && !showQuestions" class="resource-link">
          <p class="resource-text" v-html="resourceLink"></p>
        </div>
      </div>
      <section v-if="!showQuestions" class="modal-card-body" :class="{'ysc-body' : $isYSC}">
        <div v-for="(template, index) in templates" :key="index" class="template-wrapper" @click="chooseTemplate(template)" @dblclick="createProject(template)" :class="{'template-active' : selectedTemplate == template, 'disabled' : !template.templateID}" :qa="template.title">
          <img :src="template.image" />
          <div class="template-text">
            <div class="template-title">{{ template.title }}</div>
            <div class="template-desc" :class="{'ysc' : $isYSC }">{{ template.description }}</div>
          </div>
          <div v-if="!template.templateID" class="disabled-overlay"></div>
        </div>
      </section>

      <section class="questions" v-if="showQuestions">
        <div class="form">
          <div class="question-container">
            <label>{{ $t("yscCheck.question") }}</label>
            <li class="accordion-description">{{ $t("yscCheck.observe1") }}</li>
            <li class="accordion-description">{{ $t("yscCheck.observe2") }}</li>
            <li class="accordion-description">{{ $t("yscCheck.observe3") }}</li>
            <div class="question-container">
              <p>{{ $t("yscCheck.answer1") }} <strong>{{ $t("yscCheck.answer2") }}</strong> {{ $t("yscCheck.answer3") }} <a @click="openSafety()">{{ $t("yscCheck.answer4") }}</a> {{ $t("yscCheck.answer5") }}</p>
              <p>{{ $t("yscCheck.answer6") }} <strong>{{ $t("yscCheck.answer7") }}</strong> {{ $t("yscCheck.answer8") }}</p>
            </div>
          </div>
        </div>
      </section>

      <div class="button-container is-flex">
        <span class="suggest" v-if="!$isYSC">
          <p>{{ $t('chooseTemplate.notFinding')}} <a @click="suggest"> {{ $t('chooseTemplate.suggest')}}</a> {{ $t('chooseTemplate.new')}} </p>
        </span>
        <div class="cancel-and-save" :class="{'full-cancel' : $isYSC, 'extra-padding' : showQuestions}">
          <div v-if="!showQuestions" @click="close" class="button cancel is-primary is-outlined is-uppercase" qa="start-project-cancel-btn">{{ $t("cancel") }}</div>
          <div class="save button is-primary is-uppercase" @click.prevent="createProject(selectedTemplate)" :disabled="!selectedTemplate" qa="start-project-create-btn">{{createOrNext}}</div>
        </div>
      </div>
    </div>
    <categories-modal ref="categoryModal" :isCreate="true" @updateCategories="updateCategories" @forceClose="close"></categories-modal>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import componentState from '@/mixins/component-state'
import CategoriesModal from '@/components/Modals/Categories'
import i18n from '@/i18n'

export default {
  name: 'choose-template',
  components: {
    CategoriesModal
  },
  mixins: [componentState],
  data: function () {
    return {
      selectedTemplate: '',
      basicTemplates: [
        { title: i18n.t('chooseTemplate.blankTitle'), description: i18n.t('chooseTemplate.blankDesc'), templateID: 21744, image: '/static/template-icons/blank.svg' },
        { title: i18n.t('chooseTemplate.instructional'), description: i18n.t('chooseTemplate.instructionalDesc'), templateID: 23505, image: '/static/template-icons/instruct.svg' },
        { title: i18n.t('chooseTemplate.class'), description: i18n.t('chooseTemplate.classDesc'), image: '/static/template-icons/class.svg' },
        { title: i18n.t('chooseTemplate.design'), description: i18n.t('chooseTemplate.designDesc'), templateID: 225, image: '/static/template-icons/design.svg' }
      ],
      yscTemplates: [
        { title: 'Student STEM Project', description: 'A step-by-step guide to building your STEM project.', templateID: 136775, image: '/static/template-icons/english.svg' },
        { title: "Projet d'élève en STIM", description: 'Un guide « étape par étape » pour soumettre votre projet en lien avec les STIM.', templateID: 136777, image: '/static/template-icons/french.svg' }
      ],
      projectBoardTemplates: [
        { title: i18n.t('chooseTemplate.blankTitle'), description: i18n.t('chooseTemplate.blankDesc'), templateID: 130627, image: '/static/template-icons/blank.svg' },
        { title: i18n.t('chooseTemplate.instructional'), description: i18n.t('chooseTemplate.instructionalDesc'), templateID: 130628, image: '/static/template-icons/instruct.svg' },
        { title: i18n.t('chooseTemplate.class'), description: i18n.t('chooseTemplate.classDesc'), image: '/static/template-icons/class.svg' },
        { title: i18n.t('chooseTemplate.design'), description: i18n.t('chooseTemplate.designDesc'), templateID: 130629, image: '/static/template-icons/design.svg' }
      ],
      engComTemplates: [
        { title: i18n.t('chooseTemplate.blankTitle'), description: i18n.t('chooseTemplate.blankDesc'), templateID: 130630, image: '/static/template-icons/blank.svg' },
        { title: i18n.t('chooseTemplate.instructional'), description: i18n.t('chooseTemplate.instructionalDesc'), templateID: 130631, image: '/static/template-icons/instruct.svg' },
        { title: i18n.t('chooseTemplate.class'), description: i18n.t('chooseTemplate.classDesc'), image: '/static/template-icons/class.svg' },
        { title: i18n.t('chooseTemplate.design'), description: i18n.t('chooseTemplate.designDesc'), templateID: 130632, image: '/static/template-icons/design.svg' }
      ],
      tags: { categories: [] },
      showModal: true,
      showQuestions: false,
      submitted: false,
      hasDeclared: false
    }
  },
  created: function () {
    this._callback('lockScrolling')
  },
  computed: {
    templates: function () {
      return this.$isYSC ? this.yscTemplates : this.$isStories ? this.engComTemplates : this.$isProjectboard ? this.projectBoardTemplates : this.basicTemplates
    },
    createOrNext: function () {
      return this.$isYSC ? this.yscButton : this.$t('create')
    },
    yscButton: function () {
      return this.showQuestions ? 'OK' : this.$t('next')
    },
    title: function () {
      return this.showQuestions ? this.$t('template.detailsTitle') : this.$t('template.title')
    },
    required: function () {
      return this.$t('template.required')
    },
    placeholder: function () {
      return this.$t('template.placeholder')
    },
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    resourceLink: function () {
      switch (this.appName) {
        case 'ysc':
          return this.$t('template.yscResourceText')
        default:
          return false
      }
    }
  },
  methods: {
    close: function () {
      this.$emit('close')
      this._callback('unlockScrolling')
    },
    createProject: debounce(function (template) {
      if (!this.selectedTemplate) {
        return
      }
      if (!template && !this.selectedTemplate) {
        template = this.templates[0]
      }
      const tags = []
      if (this.$isYSC && this.tags.categories.length === 0) {
        if (!this.showQuestions) {
          this.questions = this.$i18n.locale === 'fr' ? this.questionsFR : this.questionsEN
          this.showQuestions = true
        } else {
          this.submitted = true
          this.$refs.categoryModal.showModal()
          this.showQuestions = false
        }
        return
      }
      if (this.selectedTemplate.title === 'Projet STIM Étudiant') {
        tags.push('french')
      } else if (this.$isYSC) {
        tags.push('english')
      }
      const selectedtags = [].concat.apply([], tags)
      const query = { projectID: template.templateID, startButton: true, draft: true, private: true, hidden: false, tags: selectedtags.filter(function (e) { return e }), category: this.tags.categories }
      if (this.$isYSC) {
        query.hidden = true
      } else if (this.$isMake) {
        query.hidden = false
        query.private = false
      }
      const path = '/start/template'
      this.$router.push({ path, query, params: this.$route.params })
      this._callback('unlockScrolling')
      this.$emit('close')
    }),
    updateCategories: function (categories) {
      for (const category in categories) {
        this.tags.categories.push(categories[category])
      }
      this.createProject(this.selectedTemplate)
    },
    chooseTemplate: function (template) {
      this.selectedTemplate = template
    },
    openVideoTour: function () {
      this.$store.dispatch('showVideoTourModal', { fromChooseTemplate: true })
      this.$emit('close')
    },
    suggest: function () {
      this.$emit('close')
      this.$router.push({ name: 'contact' })
    },
    openSafety: function () {
      if (this.$t('yscCheck.answer4') === 'Safety and Ethics in STEM') {
        window.open('https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/attachments%2FSafety%20and%20Ethics%20in%20STEM.pdf?alt=media&token=d5f1d8a4-a739-4588-9e2d-02bbe9e1a7ae')
      } else {
        window.open('https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/attachments%2FSafety%20and%20Ethics%20in%20STEM-FR.pdf?alt=media&token=0466f617-ef67-4780-8df7-6c816e170e86')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  input[type="file"] {
    display: none;
  }

  .missed-deadline {
    padding: 1rem 1.5rem;
    background-color: #F2F2F2;
    margin-top: 1rem;
    font-size: .75rem;
    font-weight: 600;
    i {
      color: $primary;
      margin-right: 1rem;
    }
  }

  .modal {
    display: flex;
  }

  .modal-card {
    letter-spacing: 0;
    padding: 50px 60px;
    background-color: white;
    max-width: 620px;
    max-height: 730px;
  }

  .close-button {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
  }

  .resource-link {
    font-size: 0.875rem;
    @include mobile {
      font-size: 0.7rem;
    }
  }

  .delete {
    background-color: white;
    color: $grey-light;
  }
  .delete::before, .modal-close::before, .delete::after, .modal-close::after {
    background-color: $grey-light;
  }

  .modal-card-body {
    padding: 20px 0;
    min-height: 540px;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-weight: normal;
    white-space: normal;
  }
  .ysc-body {
    min-height: 235px;
  }

  .modal-header {
    font-size: .9rem;
    padding: 20px 0;
    margin-bottom: 0;
    border-bottom: 1px solid $grey-lighter;
  }
  .modal-header:before{
    content: "";
    background: $primary;
    position: absolute;
    top: 106px;
    height: 1px;
    width: 87px;
  }

  .button-container {
    justify-content: space-between;
  }

  .button{
    height: auto;
    border-radius: 0;
    padding: 0.2rem 0.5rem;
  }

  .full-cancel {
    align-self: flex-end;
    text-align: right;
    flex: 2;
    display: unset !important;
    padding-top: 20px;
    z-index: 2;
    background-color: white;
  }

  .cancel-and-save {
    display: flex;
    font-weight: 600;
    div {
      margin-left: 1rem;
      border-radius: 1px;
      font-size: .65rem;
      min-width: 72px;
      height: 28px;
    }
  }
  .extra-padding {
    padding-top: 20px;
  }

  .suggest {
    font-size: 10px;
    color: #484848;
    line-height: 19px;
    a {
      text-decoration: underline;
    }
  }

  .disabled {
    cursor: not-allowed;
    pointer-events: none;
    border: none !important;
  }

  .disabled-overlay {
    background-color: $grey-lighter;
    opacity: .2;
    height: 235px;
    width: 235px;
    z-index: 1;
    position: absolute;
  }

  .template-wrapper {
    border: 1px solid #E0E0E0;
    height: 235px;
    width: 235px;
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
    align-content: flex-end;
    justify-content: space-between;
    &:hover {
      border: 1px solid #4B4B4B;
      cursor: pointer;
    }
    img {
      flex-grow: 1;
      max-width: 100px;
      max-height: 100px;
      margin: auto;
      padding-top: 10px;
    }
  }
  .template-active {
    border: 1px solid #4B4B4B;
  }
  .template-text {
    padding: 1rem;
    .template-title {
      font-size: 1rem;
      color: #373737;
      line-height: 23px;
      font-weight: bold;
    }
    .template-desc {
      font-size: .875rem;
      color: #373737;
      line-height: 19px;
      min-height: 38px;
      white-space: normal;
    }
    .ysc {
      min-height: 57px;
    }
  }

  .fa-play-circle {
    margin-right: 0.25rem;
    padding: 0.15rem;
  }

  .tour-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    position: absolute;
    top: 30px;
    right: 60px;
    p {
      font-size: 0.8rem;
      margin-right: 1rem;
    }
  }

  .tour-button {
    margin-bottom: 0.7rem;
    margin-top: 0.4rem;
    font-size: 0.7rem;
  }

  .form {
    max-width: 350px;
    margin: 0 auto;
  }

  .questions {
    overflow-y: auto;
    padding: 1rem;
    overflow: -moz-scrollbars-vertical;
  }

  .question-container {
    flex-direction: column;
    font-family: 'Roboto';
    font-size: 0.9rem;
    label {
      color: #363636;
      display: block;
      font-size: 1rem;
      font-weight: 700;
      padding: 5px 0;
      text-align: left;
    }

    .accordion {
      position: absolute;
      right: 0;
      &:hover {
        i {
          font-weight: 600;
        }
      }
    }

    .accordion-description {
      width: 100%;
      margin-top: 15px;
    }

    .checkboxes {
      flex-direction: column;
      position: relative;
      padding-left: 35px;
      padding-right: 20px;

      // hide browser default checkbox
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      input {
        display: none;
      }

      label {
        font-weight: 600;
        font-size: .9rem;
        display: inline;
        position: relative;
      }

      .checkbox-wrapper {
        padding: 10px 0;
        flex-wrap: wrap;
      }

      .checkmark {
        position: absolute;
        top: 5px;
        left: -35px;
        height: 25px;
        width: 25px;
        background-color: #eee;
        i {
          display: none;
          color: white;
          margin-left: 5px;
          margin-top: 4px;
        }
        &:hover {
          background-color: #ccc;
        }
        &:after {
          content: '';
          position: absolute;
          display: none;
        }
      }
      .radio {
        top: 5px;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        i {
          margin-left: 8px;
          margin-top: 8px;
          font-size: 9px;
        }
      }

      input:checked ~ .checkmark {
        i {
          display: block;
        }
        background-color: $primary;
      }
      input:checked ~ .checkmark:after {
        display: block;
      }
    }

    .input {
      box-shadow: none;
      border-radius: 0.2rem;
      height: 40px;
      font-size: 0.9rem;
      &:focus {
        border:1px solid lighten($primary, 10%);
        box-shadow: 0 0 0 0.125em lighten($primary, 40%);
      }
    }
    .select {
      display: block;
      &::after {
        border-color: $grey-dark;
        top: 21px;
      }
      &:hover {
        &::after {
          border-color: $primary;
        }
      }
    }
    select:-moz-focusring {
      color: transparent;
      text-shadow: 0 0 0 #000;
    }
  }

  @include mobile {
    .header-wrapper {
      padding: 1.5rem 2rem;
    }
    .modal-header:before{
      top: 80px;
    }
    .close-button {
      right: 1rem;
      top: 1rem;
    }
    .modal-card {
      min-height: 300px;
      max-width: 400px;
      padding: 0;
    }
    .modal-card-body {
      min-height: 340px;
      padding: 0 2rem;
    }
    .ysc-body {
      min-height: 180px;
      .template-wrapper {
        margin-bottom: 0;
        height: 170px;
      }
    }
    .questions {
      padding: 0 2rem;
    }
    .template-wrapper, .disabled-overlay {
      width: 140px;
      height: 140px;
      img {
        padding-top: 10px;
        max-width: 40px;
      }
      .template-title {
        font-size: .85rem;
        line-height: 1rem;
        margin-bottom: 5px;
      }
      .template-desc {
        font-size: .7rem;
        line-height: 12px;
        min-height: 23px;
      }
      .ysc {
        min-height: 48px;
        font-size: .6rem;
      }
    }
    .suggest {
      font-size: .5rem;
      line-height: 12px;
    }
    .tour-container {
      right: 45px;
      top: 20px;
      p {
        font-size: .5rem;
        margin-right: 1.65rem;
      }
      button {
        font-size: .5rem;
      }
    }
    .form {
      width: 100%;
    }
    .button-container {
      padding: 0rem 2rem 1.5rem 2rem;
    }
    .missed-deadline {
      margin: 0 1rem;
      font-size: .5rem;
    }
  }

  @include mini-mobile {
    .missed-deadline {
      margin: 0rem 2rem 1rem 2rem;
    }
  }

  @media (min-width: 450px) and (max-width: 767px) {
    .missed-deadline {
      margin: .5rem 2rem;
    }
    .header-wrapper {
      padding: 1.5 2rem 0 2rem;
    }
  }

  @media (max-width: 320px) { // Very small mobile (iPhone 5). mini-mobile wasn't working here.
    .modal-header:before {
      top: 85px;
    }
    .modal-card-body, .questions {
      padding: 0rem 1rem;
    }
    .modal-header {
      font-size: .7rem;
    }
    .header-wrapper {
      padding: 2rem 1rem;
    }
    .form {
      margin: .25rem 0;
    }
    .button-container {
      padding: 0rem 1rem 1.5rem 1rem;
    }
    .missed-deadline {
      margin: 0rem 1rem 1rem 1rem;
    }
  }

  .question-container {
    margin-top: 1rem;
    p {
      margin-top: 0.5rem;
    }
  }

</style>
